export default __webpack_public_path__ + "static/media/MarkPro-Book.8216c371.otf";